import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "plazaya_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]); // [{producto_id, cantidad, nombre, precio, imagen_url, tienda_id, plaza_id}]
  const [plazaId, setPlazaId] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setItems(parsed.items || []);
        setPlazaId(parsed.plazaId || null);
      }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ items, plazaId }));
  }, [items, plazaId]);

  const add = (producto, cantidad = 1) => {
    if (plazaId && producto.plaza_id && producto.plaza_id !== plazaId) {
      const ok = window.confirm("Este producto es de otra Plaza Comercial. Se vaciará tu carrito. ¿Continuar?");
      if (!ok) return false;
      setItems([]);
    }
    setPlazaId(producto.plaza_id || null);
    setItems(prev => {
      const existing = prev.find(i => i.producto_id === producto.id);
      if (existing) {
        return prev.map(i => i.producto_id === producto.id ? { ...i, cantidad: i.cantidad + cantidad } : i);
      }
      return [...prev, {
        producto_id: producto.id,
        nombre: producto.nombre,
        precio: producto.precio,
        imagen_url: producto.imagen_url,
        tienda_id: producto.tienda_id,
        plaza_id: producto.plaza_id,
        cantidad,
      }];
    });
    return true;
  };

  const remove = (producto_id) => setItems(prev => prev.filter(i => i.producto_id !== producto_id));
  const updateQty = (producto_id, cantidad) => {
    if (cantidad <= 0) return remove(producto_id);
    setItems(prev => prev.map(i => i.producto_id === producto_id ? { ...i, cantidad } : i));
  };
  const clear = () => { setItems([]); setPlazaId(null); };

  const count = items.reduce((s, i) => s + i.cantidad, 0);
  const subtotal = items.reduce((s, i) => s + i.precio * i.cantidad, 0);

  return (
    <CartContext.Provider value={{ items, plazaId, add, remove, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
